module.exports = __webpack_public_path__ + "img/map_dg.bea77992.png";